import React, { VFC, useState } from 'react'

import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import './Result.scss'

import Img from './Img'
import Page from './Page'
import MoreButton from './MoreButton'
import Back from './Back'
import Share from './Share'

type Info = {
  brand: string
  shop: string
  href: string
}

type Slide = {
  src: string
} & Info

type Props = {
  type: string
  slides: Slide[]
}

const Information: VFC<Info> = (props) => {
  return (
    <>
      <p className="mt-4 text-center sm:text-2xl sm:mt-6 lg:text-lg lg:mt-[38px]">
        あなたにおすすめのブランドは&hellip;
      </p>
      <p className="mt-3 font-medium text-center font-shippori-mincho text-[15px] sm:text-[30px] sm:mt-8 lg:text-xl lg:mt-[14px]">
        {props.brand}
      </p>
      <dl className="mt-5 space-y-2 font-medium text-center font-shippori-mincho sm:mt-[52px] sm:space-y-5 lg:space-y-1 lg:mt-7">
        <dt className="text-[15px] sm:text-[30px] lg:text-xl">取扱店舗</dt>
        <dd className="sm:text-2xl lg:text-base">{props.shop}</dd>
      </dl>
      <MoreButton
        className="mx-auto mt-[14px] sm:text-2xl sm:mt-7 lg:mt-[34px]"
        href={props.href}
      />
    </>
  )
}

const SingleResult: VFC<Slide> = (props) => {
  return (
    <>
      <div className="mx-auto mt-3 max-w-[245px] sm:max-w-[490px] sm:mt-[30px] lg:mt-9 lg:max-w-[525px]">
        <Img src={props.src} width="490" height="667" alt={props.brand} />
      </div>
      <Information brand={props.brand} shop={props.shop} href={props.href} />
    </>
  )
}

const Slider: VFC<{ slides: Slide[] }> = (props) => {
  const [slideIndex, setSlideIndex] = useState(0)

  return (
    <>
      <div
        id="js-slider"
        className="slider mx-auto mt-3 max-w-[245px] sm:max-w-[490px] sm:mt-[30px] lg:mt-9 lg:max-w-[525px]"
      >
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: '#js-slider .swiper-button-prev',
            nextEl: '#js-slider .swiper-button-next',
          }}
          pagination={{
            el: '#js-slider .swiper-pagination',
            clickable: true,
          }}
          onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
        >
          {props.slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <Img
                src={slide.src}
                width="490"
                height="667"
                alt={props.slides[slideIndex].brand}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-prev" />
        <div className="swiper-button-next" />
        <div className="swiper-pagination" />
      </div>

      <Information
        brand={props.slides[slideIndex].brand}
        shop={props.slides[slideIndex].shop}
        href={props.slides[slideIndex].href}
      />
    </>
  )
}

const Result: VFC<Props> = (props) => {
  return (
    <Page>
      <p className="mt-5 text-center sm:text-2xl sm:mt-11 lg:text-lg lg:mt-8">
        あなたのタイプは&hellip;
      </p>
      <p className="text-lg font-bold text-center text-custom-5 sm:text-4xl sm:mt-2 lg:text-[34px] lg:mt-3">
        {props.type}
      </p>

      {props.slides.length === 1 ? (
        <SingleResult
          src={props.slides[0].src}
          brand={props.slides[0].brand}
          shop={props.slides[0].shop}
          href={props.slides[0].href}
        />
      ) : (
        <Slider slides={props.slides} />
      )}

      <nav className="mt-8 sm:mt-[62px] lg:mt-10">
        <ul className="flex justify-center">
          <Back direction="top" text="ドレスタイプ診断TOPへ戻る" doubleArrow />
        </ul>
      </nav>

      <Share className="mt-8 sm:mt-16 lg:mt-[34px]" />
    </Page>
  )
}

export default Result
